import { HStack, Meter, Text, VStack } from '@talos/kyoko';

import { ChanceColorBand, clampChancePct, getChanceColorBand } from './chanceGaugeUtils';
import { formatPredictionOddsLabel } from './predictionDisplay';

const CHANCE_BAND_COLOR: Record<ChanceColorBand, string> = {
  [ChanceColorBand.Low]: 'colorTextNegative',
  [ChanceColorBand.Mid]: 'colorTextWarning',
  [ChanceColorBand.High]: 'colorTextPositive',
};

interface PredictionChanceMeterProps {
  chancePct: number | undefined;
}

export function PredictionChanceMeter({ chancePct }: PredictionChanceMeterProps) {
  const progress = clampChancePct(chancePct);
  const band = getChanceColorBand(progress);

  return (
    <VStack w="100%" gap="spacing6" data-testid="prediction-chance-meter" data-band={band} data-progress={progress}>
      <Meter
        value={progress / 100}
        color={CHANCE_BAND_COLOR[band]}
        showLabel={false}
        showInitialAnimation={false}
        height={8}
      />
      <HStack w="100%" justifyContent="space-between">
        <Text color="colorTextMuted" size="fontSizeTiny">
          Chance
        </Text>
        <Text color="colorTextDefault" size="fontSizeTiny">
          {formatPredictionOddsLabel(chancePct)}
        </Text>
      </HStack>
    </VStack>
  );
}
